
import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import './pagination.css';

class PaginationControl extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentPage: 0
		};
	}

	render() {
		let _pageCount = this.props.pageCountProp ? this.props.pageCountProp : 1;

		return (
			<div>
				<ReactPaginate
					pageCount={_pageCount}
					onPageChange={(data) => {
						this.props.onPageChange(data);
					}}
					previousLabel={''}
					nextLabel={''}
					breakLabel={<span className="gap">⋯</span>}
					containerClassName={'pagination'}
					pageRangeDisplayed={2}
					marginPagesDisplayed={1}
					forcePage={this.props.forcePage ? this.props.forcePage : this.state.currentPage}
					breakClassName={'breakClassName'}
					pageClassName={'pageClassName'}
					pageLinkClassName={'pageLinkClassName'}
					activeClassName={'activeClassName'}
					previousClassName={`previousClassName ${_pageCount === 1 ? 'dp-none' : ''}`}
					nextClassName={`nextClassName ${_pageCount === 1 ? 'dp-none' : ''}`}
					previousLinkClassName={'previousLinkClassName'}
					nextLinkClassName={'nextLinkClassName'}
				/>
			</div>
		);
	}
}

export default PaginationControl;
